import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { ExportDatasetToCsvResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { ToastType } from "@/enums";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";
import { useAuth } from "@/context/auth-context";

export const useExportDatasetToCsv = () => {
  const { workspaceId } = useParams();
  const auth = useAuth();
  const userToken = auth?.userToken;

  if (!workspaceId || !userToken) {
    throw new Error("Workspace ID or user token is not set");
  }

  return useMutation({
    mutationFn: async (dataset_id: number): Promise<ExportDatasetToCsvResponse> =>
      fetch(ENDPOINTS.export_dataset_to_csv(Number(workspaceId), dataset_id), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    onSuccess: (data: ExportDatasetToCsvResponse) => {
      if (data.success) {
        displayToast(data.message, ToastType.success);
      } else {
        displayErrorToast(data.error || "Export failed");
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      displayErrorToast(
        typeof error === "string" ? error : "Failed to export dataset. Please try again later.",
      );
    },
  });
};
